module.exports = __webpack_public_path__ + "8f3daa496955a9e40ebcc1947e42284d.pdf";